import React, { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from '../components/navbar';
import Home from '../pages/home/home';
import Contact from '../pages/contact/contact';
import Help from '../pages/help/help';
import RabbitAdmin from '../pages/admin/admin';
import Rescue from '../pages/rescue/rescue';

const App = () => {
  const navbarRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    if (navbarRef.current) {
      setNavHeight(navbarRef.current.offsetHeight);
    }
  }, []);

  return (
    <Router>
      <div ref={navbarRef}>
        <Navbar />
      </div>
      <div className="main-content">
        <Routes>
          {/* Define routes for each page */}
          <Route path="/" element={<Home />} />
          <Route
            path="/kontakt"
            element={<Contact navbarHeight={navHeight} />}
          />
          <Route path="/ako-pomoct" element={<Help />} />
          <Route path='/nasi-zajkovia' element={<Rescue />} />
          <Route path='/admin' element={<RabbitAdmin />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
